/**
 * For some reason, if loaded html has relative links, that only contain hash part,
 * they do not work correctly. So we need to manually add needed page path to them
 */
export function fixLocalLinks(content: string, path: string) {
  return content.replace(/\bhref="(#[^"]+)"/gi, `href="${path}$1"`)
}
